// extracted by mini-css-extract-plugin
export default {"title":"title_title__SUFWw","about":"title_about__ZK9qK","balance":"title_balance__EiF2c","timer":"title_timer__6QC9V","save":"title_save__fbRCf"};